module.exports = __webpack_public_path__ + "img/nats.13e037f7.png";